import { gql } from '@apollo/client';

export const GET_PREVIOUS_PATH = gql`
query getPreviousPath {
    previousPath @client
}
`;
